import React, { memo, ReactElement } from 'react'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { ImageSizeTypes } from '../ImageInterfaces'
import Image from '..'
import FlagImageFallback from './Fallback'

type FlagImageProps = {
    imageUrl?: string
    alt?: string
    width: number
    size: ImageSizeTypes
} & TestID

const FlagImage = ({ imageUrl, alt, size, width, testID }: FlagImageProps): ReactElement => {
    if (!imageUrl) {
        return <FlagImageFallback width={width} testID={testID} />
    }

    return (
        <Image
            width={width}
            size={size}
            resizeMode="contain"
            aspectRatio="ORIGINAL"
            imageUrl={imageUrl}
            testID={testID}
            alt={alt}
        />
    )
}
export default memo(FlagImage)
